import {
  setLocalStorage,
  getLocalStorage,
  STORAGE_KEYS,
} from "../storage/storage";

export const setRecentProductSearches = (
  searchTerm: string,
  maxRecentProductSearches: number = 5,
): void => {
  const recentProductSearches = (getRecentProductSearches() as string[]) || [];

  if (recentProductSearches.includes(searchTerm)) {
    return;
  }

  const updatedSearches = [searchTerm, ...recentProductSearches].slice(
    0,
    maxRecentProductSearches,
  );

  setLocalStorage(STORAGE_KEYS.RECENT_PRODUCT_SEARCHES, updatedSearches);
};

export const getRecentProductSearches = (): string[] => {
  return (
    (getLocalStorage(STORAGE_KEYS.RECENT_PRODUCT_SEARCHES) as string[]) || []
  );
};

export const resetRecentProductSearches = (): void => {
  setLocalStorage(STORAGE_KEYS.RECENT_PRODUCT_SEARCHES, []);
};
